module.exports = __webpack_public_path__ + "static/img/mmmp2.2fb2d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/mmmp2.png
// module id = 3pMz
// module chunks = 0